<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <fragment v-if="form">
      <EndorsementForm
        :form="form"
        @submit="submitNewEndorsement"
        name-button="CRIAR"
        @cancel="previousPage"
        is-create
      />
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPage"
      title="ENDOSSO CRIADO"
      text="Novo endosso foi criado com sucesso."
    />
    <ModalCancelEndoserment
      @close="closeModalCancel"
      v-model="modalCancelEndoserment"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import EndorsementForm from "../components/EndorsementForm";
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import ModalCancelEndoserment from "../../insurance_company/components/ModalCancelInsurance";
import RequestEndorsementMixin from "@/mixins/RequestEndorsementMixin";
export default {
  mixins: [RequestEndorsementMixin],
  data: () => ({
    form: null,
    formatDateToDDMMYYYY,
    breadcrumb: [
      {
        text: "Novo Endosso",
        to: "policy"
      }
    ],
    modal: false,
    cloneForm: {}
  }),
  components: {
    EndorsementForm,
    ModalGenericCriticism,
    ModalCancelEndoserment
  }
};
</script>
